/**
 * 
 */
(function collapsableMenuItemDirectiveDefinition() {

    'use strict';

    angular.module('CollapsableMenu')
        .directive('collapsableMenuItem', [
            function collapsableMenuItemDirective() {
                return {
                    restrict: 'A',
                    require: '^collapsableMenu',
                    link: function(scope, element, attrs, ctrl) {

                        var item = scope.$eval(attrs.collapsableMenuItem);

                        element.id = 'item' + scope.$index;

                        ctrl.itemCreated(item, element);
                    }
                };
            }
        ]);
})();